import axios from "axios";

   
   const Axios = axios.create(
    {
     //baseURL:"https://ramkrishnadharmachakra.in/ramkrishna_dharma_chakra/api/"
     //baseURL:"http://ramkrishna_dharma_chakra.mil:8082/api/"
     baseURL:"https://api.ramkrishnadharmachakra.in/api/"
    }
  
   )

   //const imageBaseURL = 'https://ramkrishnadharmachakra.in/ramkrishna_dharma_chakra/storage/app/public/'
   //const imageBaseURL = 'http://ramkrishna_dharma_chakra.mil:8082/storage/app/public/'
   const imageBaseURL = 'https://api.ramkrishnadharmachakra.in/storage/'
   
    let mainUrl={
      pgBaseUrl:Axios,
      imgBaseUrl:imageBaseURL
    }


 export default mainUrl;